// components/InactivityHandler.jsx
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const InactivityHandler = ({ children, timeout = 180000 }) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      navigate('/timeoutwarning'); 
    }, timeout);
  };

  useEffect(() => {
    // Events that reset the timer
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Start the initial timer
    resetTimer();

    // Cleanup
    return () => {
      clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [navigate, timeout]);

  return children;
};

export default InactivityHandler;
